import { render, staticRenderFns } from "./BattleUserData.vue?vue&type=template&id=533bee70&scoped=true&"
import script from "./BattleUserData.vue?vue&type=script&lang=js&"
export * from "./BattleUserData.vue?vue&type=script&lang=js&"
import style0 from "./BattleUserData.vue?vue&type=style&index=0&id=533bee70&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "533bee70",
  null
  
)

export default component.exports